import { MenuItemModel, Permission, PERMISSION_CONFIG as permissionConfig, Role } from '../../../common';
import { INSPECTION_BASE_URL } from '../../../services/config/config.service';

export function createDashboardMainMenuConfig(): MenuItemModel[] {
  const items: MenuItemModel[] = [
    {
      title: 'common.menu.home',
      icon: 'home',
      url: '/dashboard',
      permission: permissionConfig[Permission.AllUsers][Permission.Self],
    },
    {
      title: 'common.menu.dockAndYard',
      icon: 'onroad-truck-top',
      permission: permissionConfig[Permission.DockAndYard][Permission.Self],
      children: [
        {
          title: 'common.menu.hub',
          url: 'administration/hubs',
          permission: permissionConfig[Permission.DockAndYard][Permission.LocationManagement][Permission.Self],
        },
        {
          title: 'common.menu.allocationView',
          url: 'monitoring/allocation-view',
          permission: permissionConfig[Permission.DockAndYard][Permission.AllocationViews][Permission.Self],
          children: [
            {
              title: 'common.menu.profileSettings',
              url: 'monitoring/allocation-view-profiles',
              permission:
                permissionConfig[Permission.DockAndYard][Permission.AllocationViews][Permission.AllocationViewProfiles][
                  Permission.Self
                ],
            },
          ],
        },
        {
          title: 'common.menu.notaFiscale',
          icon: 'question-frame',
          url: 'nota-fiscal',
          permission: permissionConfig[Permission.DockAndYard][Permission.Self],
          requiredRole: Role.NfSupervisor,
        },
        {
          title: 'common.menu.daliView',
          permission: permissionConfig[Permission.DockAndYard][Permission.DaliView][Permission.Self],
          children: [
            {
              title: 'common.menu.daliDashboard',
              externalUrl:
                'https://app.powerbi.com/groups/d704c4f1-c223-49a9-8eb4-14fbd60a88fd/reports/e63e866f-082a-4041-9972-8e472f1ffa9a/c902d9435f19b1f03f60?experience=power-bi&clientSideAuth=0',
              permission: permissionConfig[Permission.DockAndYard][Permission.DaliView][Permission.Self],
            },
          ],
        },
        {
          title: 'common.menu.feedback',
          permission: permissionConfig[Permission.DockAndYard][Permission.Self],
          icon: 'thumb-up-down',
          externalUrl:
            'https://rb-ux-studio-fe.de.bosch.com/projects/feedback/?OfferingID=FB-0000443&Offering=Dock%20%26%20Yard&Source=Application&SourceCategory=Use&Stage=Prod&SurveyStyle=Fullscreen&FeedbackReceiverLocationID=Bp&FeedbackReceiverCountryID=HU',
        },
      ],
    },
    {
      title: 'common.menu.transportCompliance',
      icon: 'checkmark',
      externalUrl: INSPECTION_BASE_URL,
      permission: permissionConfig[Permission.AllUsers][Permission.Self],
      requiredRole: Role.ComplianceOfficer,
      featureFlagKey: 'showInspectionRedirectLink',
    },
    {
      title: 'common.menu.trackAndTrace',
      icon: 'map',
      permission: permissionConfig[Permission.TrackAndTrace][Permission.Self],
      children: [
        {
          title: 'common.menu.outbound',
          url: 'monitoring/automotive-aftermarket',
          permission: permissionConfig[Permission.TrackAndTrace][Permission.AutomotiveAftermarket][Permission.Self],
          children: [
            {
              title: 'common.menu.profileSettings',
              url: 'monitoring/automotive-aftermarket-profiles',
              permission: permissionConfig[Permission.AllUsers][Permission.Self],
            },
          ],
        },
        {
          title: 'common.menu.transportManagement',
          url: 'monitoring/transport-management',
          permission: permissionConfig[Permission.TrackAndTrace][Permission.TmSc1Sc4][Permission.Self],
          children: [
            {
              title: 'common.menu.profileSettings',
              url: 'monitoring/transport-management-profiles',
              permission: permissionConfig[Permission.AllUsers][Permission.Self],
            },
          ],
        },
        {
          title: 'common.menu.myTransports',
          url: 'monitoring/shipments',
          permission: permissionConfig[Permission.TrackAndTrace][Permission.CanaryTransportLevel][Permission.Self],
          children: [
            {
              title: 'common.menu.profileSettings',
              url: 'monitoring/shipment-profiles',
              permission: permissionConfig[Permission.TrackAndTrace][Permission.CanaryTransportLevel][Permission.Self],
            },
          ],
        },
        {
          title: 'common.menu.myTransportsNextGen',
          url: 'monitoring/shipments-next',
          permission: permissionConfig[Permission.TrackAndTrace][Permission.MyTransportsNewGen][Permission.Self],
        },
        {
          title: 'common.menu.feedback',
          permission: permissionConfig[Permission.TrackAndTrace][Permission.Self],
          icon: 'thumb-up-down',
          externalUrl:
            'https://rb-ux-studio-fe.de.bosch.com/projects/feedback/?OfferingID=FB-0000447&Offering=Track%20%26%20Trace&Source=Application&SourceCategory=Use&Stage=Prod&SurveyStyle=Fullscreen&FeedbackReceiverLocationID=St&FeedbackReceiverCountryID=DE',
        },
      ],
    },
    {
      title: 'common.menu.administration',
      icon: 'settings',
      permission: permissionConfig[Permission.Administration][Permission.Self],
      children: [
        {
          title: 'common.menu.userManagement',
          permission: permissionConfig[Permission.Administration][Permission.UserManagement][Permission.Self],
          children: [
            {
              title: 'common.menu.users',
              url: 'administration/user-management/users',
              permission:
                permissionConfig[Permission.Administration][Permission.UserManagement][Permission.Users][
                  Permission.Read
                ],
            },
            {
              title: 'administration.user.list.truckDrivers',
              url: 'administration/user-management/truck-drivers',
              permission:
                permissionConfig[Permission.Administration][Permission.UserManagement][Permission.Drivers][
                  Permission.Self
                ],
            },
          ],
        },
        {
          title: 'common.menu.partnerManagement',
          url: 'administration/partners',
          permission: permissionConfig[Permission.Administration][Permission.PartnerManagement][Permission.Self],
        },
        {
          title: 'common.menu.addressManagement',
          url: 'administration/address-management',
          permission: permissionConfig[Permission.Administration][Permission.AddressManagement][Permission.Self],
        },
        {
          title: 'common.menu.apiConfiguration',
          url: 'administration/api-connections',
          permission: permissionConfig[Permission.Administration][Permission.ApiConfiguration][Permission.Self],
        },
        {
          title: 'common.menu.plantManagement',
          url: 'administration/plants',
          permission: permissionConfig[Permission.Administration][Permission.PlantManagement][Permission.Self],
        },
        {
          title: 'common.menu.sapEtaUp',
          url: 'administration/sap-eta-configuration',
          permission: permissionConfig[Permission.Administration][Permission.SapEtaUp][Permission.Self],
        },
        {
          title: 'common.menu.containerManualUpload',
          url: 'administration/container-manual-upload',
          permission: permissionConfig[Permission.Administration][Permission.ContainerManualUpload][Permission.Self],
        },
        // Hiding menu for 10907. Not deleting related files from intrack-features as we might have to reinstate the feature.
        //{
        //  title: 'common.menu.organizations',
        //  url: 'administration/organizations',
        //  permission: permissionConfig[Permission.Administration][Permission.Organizations][Permission.Self],
        //},
        {
          title: 'common.menu.dpn',
          url: 'administration/data-protection-notice',
          permission: permissionConfig[Permission.Administration][Permission.DataProtectionNotice][Permission.Self],
        },
        {
          title: 'common.menu.eula',
          url: 'administration/end-user-license-agreement',
          permission: permissionConfig[Permission.Administration][Permission.EndUserLicenseAgreement][Permission.Self],
        },
        {
          title: 'common.menu.newsletters',
          url: 'administration/newsletters',
          permission: permissionConfig[Permission.Administration][Permission.Newsletters][Permission.Self],
        },
      ],
    },
    {
      title: 'common.menu.reports',
      icon: 'checklist-stack',
      permission: permissionConfig[Permission.Reports][Permission.Self],
      children: [
        {
          title: 'common.menu.userDataChanges',
          url: 'reports/user-data-changes',
          permission: permissionConfig[Permission.Reports][Permission.UserDataChanges][Permission.Self],
        },
        {
          title: 'common.menu.masterDataReports',
          url: 'reports/master-data',
          permission: permissionConfig[Permission.Reports][Permission.MasterData][Permission.Self],
        },
      ],
    },
    {
      title: 'common.menu.exports',
      permission: permissionConfig[Permission.Exports][Permission.Self],
      icon: 'download-frame',
      url: 'exports',
    },
    {
      title: 'common.menu.dataQuality',
      permission: permissionConfig[Permission.DataQuality][Permission.Self],
      icon: 'data-center',
      children: [
        {
          title: 'common.menu.failedMessages',
          url: 'data-quality/failed-messages',
          permission: permissionConfig[Permission.DataQuality][Permission.Self],
          children: [
            {
              title: 'common.menu.profileSettings',
              url: 'data-quality/failed-messages-profiles',
              permission: permissionConfig[Permission.DataQuality][Permission.Self],
            },
          ],
        },
        {
          title: 'common.menu.messageChecker',
          url: 'data-quality/message-checker',
          permission: permissionConfig[Permission.DataQuality][Permission.Self],
        },
      ],
    },
  ];
  return items;
}
